var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{domProps:{"value":_vm.value},on:{"input":function($event){return _vm.emit($event.target.value)}}},_vm._l((_vm.options),function(option,key){return _c('option',{domProps:{"value":key}},[_vm._v(_vm._s(option))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }